var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"detail-title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{ref:"qrCodeDiv",staticClass:"ewmcode",attrs:{"id":"qrCode"}}),_c('div',{staticClass:"detail-info"},[_vm._v("检查时，请出示此二维码。")]),_c('div',{staticClass:"detail-info"},[_vm._v(" 离院后如需咨询医生，请关闭此页，点击公众号左下角菜单“在线咨询”，按提示选择医生咨询 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }